module.exports = __webpack_public_path__ + "static/media/file-solid.f966d9d6.svg";